import { IBudget } from "../../../../models/budgetV2";
import { isClientApprovedStatus } from "./useBudgetEdit";

const PERSONA_ROLE: Record<string, string> = {
    "fleet-manager": "MANAGER",
    "dealership": "CONSULTANT",
    "control-tower": "FACTORY",
};

// Backend decisions update budget.recipient/status (top-level) but not the version's own recipient,
// so the top-level fields are the source of truth for who is responsible right now.
export const useBudgetCanAct = (budget: IBudget | null, loading: boolean, persona: string): boolean => {
    if (loading || !budget) return false;

    const currentStatus = budget.statusLabel ?? budget.versionData?.statusLabel ?? budget.currentUserStatus ?? "";
    const isFinished =
        isClientApprovedStatus(currentStatus) ||
        Boolean(budget.versionData?.counterProposalApprovedAt) ||
        /recusado|rejeitado|rejected/i.test(currentStatus);
    const isLatestVersion =
        !budget.lastVersionNumber || !budget.versionData?.versionNumber ||
        budget.versionData.versionNumber === budget.lastVersionNumber;
    const isResponsible = !!PERSONA_ROLE[persona] && budget.recipient === PERSONA_ROLE[persona];

    return !isFinished && isLatestVersion && isResponsible;
};
